import { DealerLocationID } from "./DealerLocation";

export type ParkingGateCodeID = number;

export interface ParkingGateCode {
  created_on: string;
  updated_on: string;
  id: ParkingGateCodeID;
  pin: string; // Parking gate code
  start_at: string; // Parking gate code is valid from this time
  end_at: string; // Parking gate code is expired at this time
  dealer_location_id: DealerLocationID; // Dealer Location Identifier
}
